import Modal from 'react-modal';
import { Trans, useTranslation } from 'react-i18next';
import { colors } from 'components/styles/variables';

interface CloseModalProps {
  isModalOpen: boolean;
  onLeave: () => void;
  onCancel: () => void;
}

const closeModalStyles: ReactModal.Styles = {
  content: {
    height: 244,
    width: 280,
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    overflow: 'hidden',
    padding: 0,
  },
  overlay: {
    zIndex: 1000,
    overflow: 'hidden',
    backgroundColor: 'rgba(0,0,0,0.4)',
  },
};

export default function CloseModal({
  isModalOpen,
  onLeave,
  onCancel,
}: CloseModalProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <>
      <Modal
        isOpen={isModalOpen}
        onRequestClose={onCancel}
        shouldCloseOnOverlayClick={true}
        style={closeModalStyles}
      >
        <div className="close-modal-content">
          <div className="close-modal-header">
            <Trans i18nKey="onboarding.exitScreen.header" components={[<br />]} />
          </div>
          <div className="close-modal-subtext">
            <Trans i18nKey="onboarding.exitScreen.warning" components={[<br />, <br />]} />
          </div>
          <div className="close-modal-cta-container">
            <button className="leave-button" onClick={onLeave}>
              {t('onboarding.exitScreen.leave')}
            </button>
            <button className="cancel-button" onClick={onCancel}>
              {t('onboarding.exitScreen.cancel')}
            </button>
          </div>
        </div>
      </Modal>
      <style jsx>{`
        .close-modal-content {
          border-radius: 8px;
          background-color: ${colors.WHITE};
          opacity: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          text-align: center;
          overflow: hidden;
        }
        .close-modal-header {
          font-size: 18px;
          font-style: normal;
          font-weight: 700;
          line-height: 22px;
          letter-spacing: 0.2px;
          margin-top: 24px;
        }
        .close-modal-subtext {
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 24px;
          letter-spacing: 0.2px;
          margin: 12px 0 32px 0;
        }
        .leave-button {
          width: 116px;
          height: 44px;
          background-color: ${colors.ALR1};
          color: ${colors.WHITE};
          border-radius: 4px;
          border: none;
          margin-right: 16px;
        }
        .cancel-button {
          width: 116px;
          height: 44px;
          color: ${colors.BLACK};
          background-color: ${colors.WHITE};
          border-color: ${colors.G2};
          border-style: solid;
          border-width: 1px;
          border-radius: 4px;
        }
      `}</style>
    </>
  );
}
